import { Link } from 'react-router-dom';
import AnimatedPage from '../components/shared/AnimatedPage';

export default function NotFoundPage() {
  return (
    <AnimatedPage>
      <div className="flex min-h-screen flex-col items-center justify-center px-4 text-center">
        <h1 className="text-6xl font-bold text-gray-300">404</h1>
        <p className="mt-4 text-lg text-gray-600">Page not found</p>
        <Link
          to="/"
          className="mt-6 inline-flex min-h-touch min-w-touch items-center rounded-full bg-brand-600 px-6 py-2 text-sm font-semibold text-white hover:bg-brand-700"
        >
          Go Home
        </Link>
      </div>
    </AnimatedPage>
  );
}
